import { render, staticRenderFns } from "./PcCappedCard2.vue?vue&type=template&id=12de8d2c&scoped=true"
import script from "./PcCappedCard2.vue?vue&type=script&lang=js"
export * from "./PcCappedCard2.vue?vue&type=script&lang=js"
import style0 from "./PcCappedCard2.vue?vue&type=style&index=0&id=12de8d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de8d2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCard,VCardText,VIcon,VToolbar,VToolbarTitle})
